import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import kolumbusFrontend from '@geta/kolumbus-admin-frontend';
import router from '@/plugins/router';
import '@/styles/main.scss';

createApp(App).use(kolumbusFrontend).use(router).use(createPinia()).mount('#app');
